import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { DownloadMenu } from '../DownloadMenu'
import { DownloadButton } from './components'
import { useDownloadButtonMenu } from './useDownloadButtonMenu'

export const DownloadButtonMenu: React.FC = () => {
  const { onClick } = useDownloadButtonMenu()

  return (
    <DropdownMenu.Root onClick={onClick} content={DownloadMenu}>
      <DownloadButton />
    </DropdownMenu.Root>
  )
}
